import { lazy, useMemo } from "react";
import DefaultLayout from "../../layout/default/DefaultLayout";
import { routePaths } from "../../util/constants";

const Nng = lazy(() => import("../nng/Nng"));

const useAppRoutes = () => {
  const routes = useMemo(() => {
    return [
      {
        path: routePaths.NNG,
        component: Nng,
        layout: DefaultLayout,
        canSeeRoute: true,
        redirectTo: routePaths.NNG,
      },
    ];
  }, []);

  return [routes];
};

export default useAppRoutes;
